import styled, { css } from 'styled-components'
import DatePicker from '../../containers/DatePicker'
import { 
    SvgArrowForward, 
    SvgArrowDownload, 
    SvgArrowBack, 
    SvgArrowUp, 
    SvgFileDownload, 
    SvgChevronRight,
    SvgFilter,
    Phone,
    ArrowRight,
} from '../../assets/icons'
import { useState } from 'react'

const ArrowDownIcon = styled.i`
    cursor: pointer;

    @media screen and (max-width: 950px) { 
        width: 22px;
        height: 22px;
        --ggs: 0.7;

        .gg-arrow-down::after {
            width: 8px;
            height: 8px;
            border-bottom: 2px solid;
            border-left: 2px solid;
            transform: rotate(-45deg);
            left: 7px
        }
        .gg-arrow-down::before {
            width: 2px;
            height: 16px;
            left: 10px;
            background: currentColor
        }

    }
`

const MenuIcon = styled.i`
    --ggs: 1.2;
`
export const CommomButton = styled.button`
    display: flex;
    border: 0;
    outline: none;
    border-radius: 48px;
    background: #FF9800 0% 0% no-repeat padding-box;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    height: 42px;
    padding: 0 16.62px;
    font-size: 16px;
    margin-top: ${({ mtD }) => mtD || '0'};
    width: ${({width}) => width || 'fit-content'};
    text-decoration: none !important;
    color: #000;

    @media(max-width: 950px) {
        font-size: 13px;
        height: 33px;
        padding: 0 10.63px;
        margin-top: ${({ mtM }) => mtM || '0'};
    }
`

const ButtonCta = styled(CommomButton)`
  color: #000;
  font-size: 16px;
  width: fit-content;

  @media(max-width: 950px) {
      font-size: 13px;
  }

  @media screen and (min-width: 801px) and (max-width: 1280px) { 
    height: 40px;
   }
`
const DownButton = styled.div`
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FF9800;
    border-radius: 50%;
    cursor: pointer;
    bottom: 4%;
    color: black;
    width: 43px;
    height: 43px;

    @media screen and (max-width: 950px) { 
        position: relative;
        width: 33px;
        height: 33px;
    }
`
export const MobileHeader = styled.div`
    display: none;
    align-items: center;
    justify-content: center;
    width: 178px;
    height: 44px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 86px;
    font-size: 13px;
    line-height: 19px;
    cursor: pointer;
    font-weight: bold;

    @media screen and (max-width: 950px) { 
        display: flex;
    }
`
export const CTA = ({ onClick }) => {
    return (
        <ButtonCta onClick={onClick}> <span> <b> Peça seu orçamento </b> </span> </ButtonCta>
    )
}

export const Down = ({ onClick, id }) => {
    return (
        <DownButton id={id} onClick={onClick}>
            <ArrowDownIcon className="gg-arrow-down" />
        </DownButton>
    )
}

export const CommomButtonIcon = styled(CommomButton)`
   justify-content: ${({ justifyContent }) => justifyContent || 'center'};

    i {
        margin-left: 16.62px;

        @media(max-width: 950px) {
            margin-left: 7.33px;
        }
    }

    @media(max-width: 950px) {
        padding-right: 7.33px;
    }
`

export const CardButtonIcon = styled(CommomButtonIcon)`
    font-weight: bold;
    border-radius: 19px;
    height: 37px;
    font-size: 15px;
    
    b {
        font-size: 13px;
    }
    

    @media(max-width: 950px) {
        padding: 0 11px 0 14px;
        height: 29px;
        font-size: 11px;

        b {
            font-size: 11px !important;
        }

        i {
            margin-left: 1px;
            --ggs: 0.6;
        }
    }
`
export const ButtonConfim = styled.button`
    width: 116px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FF9800 0% 0% no-repeat padding-box;
    font-weight: bold;
    border-radius: 19px;
    outline: none;
    border: none;
    cursor: pointer;
    padding: 8px 0;
    font-size: 12px;
    color: black;

    ${({ off }) => off && css`
        background: #DEDEDE 0% 0% no-repeat padding-box;
        font-weight: normal;
        color: #595959;
    `};
`
export const SelectButton = styled.button`
    background: ${({ background }) => `${background}`};
    color: ${({ color = '#000' }) => `${color}`};
    display: flex;
    outline: none;
    border-radius: 48px;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    border: 0;
    font-size: 18px;
    width: 154px;
    height: 42px;

    ${( { moodboard } ) => moodboard && css `
        height: 33px;
        width: 105px;
        font-size: 13px;
    `}

    @media (max-width: 950px) {
        width: 66px;
        height: 24px;
        font-size: 9px;
    }
`

export const LeftButton = styled.div`
    position: absolute;
    display: none;
    align-items: center;
    justify-content: center;
    background: #FF9800;
    border-radius: 50%;
    cursor: pointer;
    bottom: 2%;
    color: black;

    width: 68px;
    height: 68px;

    @media (max-width: 950px) { 
        display: flex;
        position: relative;
        width: 33px;
        height: 33px;
        margin-left: ${({ ml }) => ml || '0'};

        span {
            font-size: 24px;
        }
    }
`
export const ConfirmButton = styled.div`
    height: 60px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 86px;
    align-self: center;
    padding: 18px;
    font-size: 18px;
    font-weight: bold;
`
export const PlansButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    outline: none;
    border: none;
    border: 1px solid #707070;
    border-radius: 15px;
    padding: 3.5px 0;
    cursor: pointer;

    &:hover {
        background: #FD9700 0% 0% no-repeat padding-box;
        color: #fff;
    }

    ${({ selected }) => selected && css`
        background: #000;
        color: #fff;
    `}
`
export const ButtonAdm = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    outline: none;
    border: 1px solid #707070;
    border-radius: 15px;
    padding: ${({ padding = 0 }) =>  padding};
    cursor: pointer;
    font-weight: bold;
    font-size: 11px;

    ${({ positive }) => positive && css`
        background: #FF9800;
        border: none;
    `}
`
export const Calculator = ({ onClick, fixed, alignRight }) => {
    return (
        <CalculatorButton onClick={ onClick } fixed={fixed} alignRight={alignRight}>
            <i className="gg-calculator" />
        </CalculatorButton>
    )
}

const CommomButtonWrapper = styled.button`
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 48px;
    border: none;
    padding: 10px 26px;
    font-size: ${({ font }) => font || "13px"};
    font-weight: bold;
    cursor: pointer;
    outline: none;
    color: "#000";
`

const AccountButton = styled(CommomButtonIcon)`
    position: relative;
    width: ${({ width }) => width || 'fit-content'};
    background: ${({ background }) => background || '#FF9800'};
    justify-content: space-between;
    color: ${({ color }) => color || '#000'};
`
const AcceptWrapper = styled.div`
    display: flex;
    align-items: center;
    color: black;

    @media(max-width: 600px) {
        position: relative;
        width: 300px;
        height: 50px;
    }
`
const SendWrapper = styled(AcceptWrapper)`
    width: 100%;
    max-width: 100%;
    justify-content: flex-end;
    position: relative;
    margin-top: 90px;

    @media(max-width: 950px) {
        padding: 0 6%;
    }
`
export const ButtonBack = styled.button`
    position: relative;
    width: 180px;
    height: 42px;
    background: #DFDFDF 0% 0% no-repeat padding-box;
    border-radius: 86px;
    outline: none;
    border: none;
    font-weight: 800;
    left: 50px;
    cursor: pointer;
    padding-right: 25px;
    color: black;
`
export const ComparatorClose = styled.div`
    display: flex;
    width: 53px;
    height: 77px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 39px;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    cursor: pointer;

    @media (max-width: 950px) {
        width: 36px;
        height: 59px;
    }

    i {
        --ggs: 1.5;

        @media (max-width: 950px) {
            --ggs: 1;
        }
        position: relative;
        right: 1px;
    }

`

export const ComparatorButton = styled.button`
    display: flex;
    border: 0;
    outline: none;
    border-radius: 39px 39px 0px 0px;
    background: #FF9800 0% 0% no-repeat padding-box;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    width: 53px;
    height: 64px;
    margin: 0 5%;
    align-self: flex-end;
    color: #000;

    @media(max-width: 950px){
        align-self: flex-start;
        width: 36px;
        height: 63px;
        padding-top: 10px;
        align-items: flex-start;
    }

    i {
        --ggs: 1.5;

        @media (max-width: 950px) {
            --ggs: 1;
        }
        position: relative;
        right: 1px;
    }
`
const CalculatorButton = styled.button`
    display: none;
    color: #000;

    @media (max-width: 950px) {
        background: #FF9800 0% 0% no-repeat padding-box;
        border: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 33px;
        border-radius: 50%;
        margin-left: 20px;

        i {
            --ggs: 0.8;
            margin: 0 auto;
        }
    }

    ${({ fixed }) => fixed && css`
        position: fixed;
        bottom: 15px;
        margin 0!important;
        right: 15px;
    `}

    ${({ alignRight }) => alignRight && css`
        position: absolute;
        margin-left: 0 !important;
        right: 10%;
    `} 
`

const BackRegister = styled(ButtonBack)`
    width: 100%;
    position: absolute;
    left: 0;
    padding: 0;
    text-align: center;
    display: flex;
    align-items: center;
    padding-left: 13px;

    span {
        margin-right: 22px;
    }

    @media(max-width: 950px) {
        display: none;
    }
`
const AcceptCompBack = styled(ButtonBack)`
    align-items: center;
    display: flex;
    justify-content: space-around;

    .btn_back {
        position: relative;
        right: 28px;
    }

    @media(max-width: 600px) {
        position: absolute;
        height: 30px;
        width: 140px;
        font-size: 10px;
        left: 0;
        padding-right: 0;

        .material-icons-outlined {
            right: 10px;
            font-size: 18px;
            position: relative
        }

        ${({ user_contact }) => user_contact && css`
            width: 116px;
        `}

    }
`
const AcceptButton = styled.button`
    width: 253px;
    height: 60px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 86px;
    outline: none;
    border: none;
    font-weight: 800;
    z-index: 1;
    cursor: pointer;
    font-size: 18px;
    color: black;

    ${({ user_contact }) => user_contact && css`
        width: 300px;
    `}

    ${({ contact }) => contact && css`
        background: #CCFF72 0% 0% no-repeat padding-box;
    `}
`
const SendButton = styled(AcceptButton)`
    width: 326px;
    height: 49px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 17px 0 25px;

    span {
        font-size: 36px;
    }

    @media(max-width: 950px) {
        height: 44px;
        width: 100%;
        font-size: 13px;

        span {
            font-size: 24px;
        }
    }
`
const AcceptCompButton = styled(AcceptButton)`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 17px 0 19px;

    .material-icons-outlined {
        left: 20px;
        position: relative;
    }

    ${({ user_contact }) => user_contact && css`
    
        .material-icons-outlined {
            left: 0;
            position: relative;
        }

    `}

    @media(max-width: 600px) {

        position: absolute;
        right: 0;
        height: 44px;
        width: 175px;
        font-size: 13px;

        .material-icons-outlined {
            left: 14px;
            font-size: 18px;
            position: relative
        }

        ${({ user_contact }) => user_contact && css`
            width: 211px;

            .material-icons-outlined {
                left: 0;
                position: relative
            }

        `}

    }

    ${({ name }) => name === 'view_comp' && css`
        width: 350px;
    `}
`
const ButtonFilter = styled.button`
    height: 60px;
    width: 100%;
    background: #FF9800 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 86px;
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    padding: 18px 16px 18px 19px;
    font-weight: bold;
    color: #000;

    @media (max-width: 950px) {
       height: 44px;
       font-size: 13px;

       span {
        font-size: 24px!important;
       }
    }

    @media (max-width: 600px) {
        padding: 18px 14px 18px 19px;
    }

    ${({ logButton }) => logButton && css`
        height: 49px;
        font-size: 15px;
    `}
`
const ButtonInformation = styled.button`
    width: 125px;
    height: 29px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 13px;
    border: none;
    cursor: pointer;
    color: black;

    span {
        font-size: 11px;
        font-weight: bold;
    }

    i {
        --ggs: 0.7;
        left: 5px;
    }

    .full_info {
        display: block;
    }

     .mobile_info {
        display: none;
    }

    @media (max-width: 600px) {

        width: 65px;

       .full_info {
          display: none;
       }

       .mobile_info {
          display: block;
       }

    }
`
const ButtonScrollTop = styled.button`
    width: 33px;
    height: 33px;
    min-height: 33px;;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FF9800 0% 0% no-repeat padding-box;
    outline: none;
    cursor: pointer;
    border-radius: 50%;
    border: 0;
    align-self: flex-end;
    color: black;

    @media (max-width: 950px) {
        align-self: center;
    }
`
const LoadMore = styled.button`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 29px;
    background: #C5C5C5 0% 0% no-repeat padding-box;
    border-radius: 19px;
    align-self: center;
    padding: 16px 16px;
    cursor: pointer;
    border: none;
    font-size: 12px;
    font-weight: bold;
    line-height: 18px;
    margin-bottom: 40px;
    color: #000;

    span {
      margin-left: 8px;
      color: #000;
    }
`
const GoBackButton = styled(CommomButton)`
    width: 33px;
    height: 33px;
    border-radius: 50%;
`
const MobileBack = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33px;
    height: 33px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 50%;
    cursor: pointer;
    color: black;
`
const ResumeDownload = styled.button`
    display: flex;
    align-items: center;
    border: 1px solid #000000;
    border-radius: 21px;
    padding: 0 20px;
    height: 41px;
    cursor: pointer;

    svg {
        margin-right: 8px;
    }

    span {
        font-weight: bold;
        font-size: 15px;
    }
`
const AdminFilterWrapper = styled.div`
    position: relative;
    display: flex;
`

const AdminFilter = styled.button`
    display: flex;
    align-items: center;
    border-radius: 21px;
    padding: 0 4px 0 16px;
    height: 41px;
    cursor: pointer;
    background: #FF9800 0% 0% no-repeat padding-box;
    border: none;

    svg:nth-child(1n){
        margin-right: 8px;
    }

    svg:nth-child(3n){
        margin-left: 8px;
    }

    span {
        font-weight: bold;
        font-size: 15px;
    }
`
const FilterDateWrapper = styled.div`
    position: absolute;
    width: 305px;
    height: fit-content;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: -8px 19px 22px #00000029;
    border-radius: 18px;
    right: 0;
    top: 50px;
    padding: 15px;
`
const AdmButtonWrapper = styled.button`
    display: flex;
    align-items: center;
    padding: 0 42px 0 32px;
    justify-content: space-between;
    width: 100%;
    max-width: 400px;
    height: 68px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 34px;
    border: none;
    outline: none;
    cursor: pointer;

    span {
        font-size: 21px;
    }
`
const RangeDateFooter = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    border-top: 1px solid #ccc;
    padding-top: 14px;
    margin-top: 14px;
`
const RangeButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75px;
    height: 29px;
    border-radius: 19px;
    border: none;
    font-size: 11px;
    font-weight: bold;
    cursor: pointer;
`
const RangeButtonFilter = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 94px;
    height: 29px;
    background: #FF9800;
    border-radius: 19px;
    border: none;
    font-size: 11px;
    font-weight: bold;
    cursor: pointer;
`
export const ItemListButton = styled.button`
    cursor: pointer;
    display: flex;
    width: 34px;
    height: 100%;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 17px;
    border: none;
    align-items: center;
    justify-content: center;
`
export const ChooseWrapper = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 144px;
    height: 36px;
    border: 1px solid #707070;
    border-radius: 18px;
    cursor: pointer;
    background: #fff;
    font-weight: bold;
    font-size: 12px;
    align-self: center;
`
export const BudgetLinkButton = styled.button`
    display: flex;
    width: 100%;
    max-width: 364px;
    min-height: 80px;
    background: ${({ color }) => color || `#FF9800`};
    outline: none;
    border-radius: 16px;
    border: none;
    font-size: 24px;
    font-weight: 500;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
    cursor: pointer;
    color: ${({ textColor }) => textColor || `#000000`};

    @media screen and (max-width: 1366px) {
        margin-bottom: 40px;
    }

    @media screen and (max-width: 768px) {
      display: none;
    }

    ${({ showMobile }) => showMobile && css`

        display: none;

        @media screen and (max-width: 768px) {
            display: block;
            max-width: 235px;
            font-size: 16px;
            min-height: 50px;
            border-radius: 9px;
            align-self: center;
            margin-top: 18px;
            margin-bottom: 0px;
        }

    `}

`
const ArrowLeftIcon = styled.i`
    --ggs: 0.6;
`
export const ContactLink = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;
    max-width: 671px;
    border: none;
    outline: none;
    border-radius: 16px;
    font-size: 24px;
    font-weight: 500;
    box-shadow: 1px 20px 35px #FF98005E;
    cursor: pointer;
    color: ${({ textColor }) => textColor || `#000000`};

    ${({ bgColor = "#FF9800"}) => bgColor && css`
        background: ${bgColor};
    `}

    ${({ noShadow }) => noShadow && css`
        box-shadow: none;
    `}

    ${({ margin }) => margin && css`
        margin: ${margin};
    `}

    @media screen and (max-width: 768px) {
        height: 52px;
        font: normal normal 500 16px/29px Poppins;
        letter-spacing: 0.26px;

        ${({ mobmargin }) => mobmargin && css`
            margin: ${mobmargin};
        `}
    }
`
export const GreyButton = styled(CommomButton)`
    background: #E0E0DF 0% 0% no-repeat padding-box;
    margin-top: ${({ marginTop }) => `${marginTop}px`};
`
export const GreyButtonIcon = styled(CommomButtonIcon)`
    background: #E0E0DF 0% 0% no-repeat padding-box;
    margin-top: ${({ marginTop }) => `${marginTop}px`};
`
const SendMapButton = styled.button`
    display: flex;
    align-items: center;
    padding: 0 16px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 48px;
    width: 100%;
    height: 42px;
    border: none;
    justify-content: space-between;
    cursor: pointer;
    color: #000;

    span {
        font-size: 15px;
        line-height: 23px;
        font-weight: bold;
    }
`
const HeaderButtonWrapper = styled.button`
    display: flex;
    width: 390px;
    min-height: 80px;
    background: #FF9800;
    border-radius: 16px;
    outline: none;
    border: none;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 1px 20px 35px #FF98005E;
    color: #000;

    span {
        font-size: 24px;
        font-weight: 500;
    }

    @media only screen and (max-width: 950px) {
        text-align: center;
        width: 100%;
        max-width: 235px;
        min-height: 52px;
        margin-bottom: 35px;

        span {
            font-size: 16px;
            line-height: 29px;
        }

    }
`
const UploadButton = styled(CommomButtonIcon)`
    background: #212322;
    color: white;
    justify-content: space-between;
    width: 100%;
    
    span {
        font-weight: normal;
        font-size: 14px;
    }

    @media (max-width: 950px) {
        width: 100%;
        padding: 0 20px 0 18px;
    }
`

export const MapButtonSend = ({ onClick, title }) => {
    return (
        <SendMapButton onClick={onClick}> 
            <div />
            <span> { title } </span>
            <ArrowRight />
        </SendMapButton>
    )
}

export const UserAction = ({ onClick, text, width, background, color, type }) => {
    return (
        <AccountButton type={type} onClick={onClick} width={width} background={background} color={color}>
            { text }
            <i className="gg-arrow-right" />
        </AccountButton>
    )
}

const SelectAllButton = styled(GreyButton)`
    background: ${({ background }) => `${background}`};
    color: ${({ color }) => `${color}`};
    border-radius: 74px;
    font-size: 18px;

    @media (max-width: 950px) {
        font-size: 13px;
        margin-top: 3rem;
    }
`
export const SelectAll = ({ onClick, selected }) => {
    return (
        <SelectAllButton 
            onClick={onClick}
            background={selected ? '#212322' : '#C8C9C7'} 
            color={selected ? '#FFFFFF' : ''}
        >  
            <span> {selected ? 'limpar seleção' : 'selecionar tudo'} </span> 
        </SelectAllButton>
    )
}

export const Left = ({ onClick, ml }) => {
    return (
        <LeftButton onClick={onClick} ml={ml}>
           <SvgArrowBack />
        </LeftButton>
    )
} 

export const Select = ({ onClick, selected, moodboard }) => {
    return (
        <SelectButton 
            onClick={onClick}
            background={selected ? '#212322' : '#C8C9C7'} 
            color={selected ? '#FFFFFF' : '#000'}
            moodboard={moodboard}
        >  
            <span> {selected ? 'selecionado' : 'selecionar'} </span> 
        </SelectButton>
    )
}

export const VisualizeCompetitors = ({ onBack, accept, text, contact, user_contact, adm }) => {
    return (
        <AcceptWrapper>
            <AcceptCompBack onClick={onBack} user_contact={user_contact}>                 
                <SvgArrowBack name="button" />
                <span className="btn_back"> Voltar </span> 
            </AcceptCompBack>
            { !adm && (
                <AcceptCompButton 
                    onClick={accept} 
                    contact={contact}
                    user_contact={user_contact}
                    name="view_comp"
                > 
                    {text}
                    <SvgArrowForward name="accept_project" />
                </AcceptCompButton>
            )}
        </AcceptWrapper>
    )
}

export const AcceptCompetition = ({ onBack, accept, text, contact, user_contact }) => {
    return (
        <AcceptWrapper>
            <AcceptCompBack onClick={onBack} user_contact={user_contact}>                 
                <SvgArrowBack name="button" />
                <span className="btn_back"> Voltar </span> 
            </AcceptCompBack>
            <AcceptCompButton 
                onClick={accept} 
                contact={contact}
                user_contact={user_contact}
            > 
                {text}
                <SvgArrowForward name="accept_project" />
            </AcceptCompButton>
        </AcceptWrapper>
    )
}

export const SendRegiser = ({ onBack, send, text, name }) => {
    return (
        <SendWrapper>
            <BackRegister onClick={onBack}>
                <SvgArrowBack name={name} />
                Voltar 
            </BackRegister>
            <SendButton onClick={send}> 
                {text} 
                <SvgArrowForward name="register_user" />
            </SendButton>
        </SendWrapper>
    )
}

export const FilterButton = ({ onClick, text, logButton, type }) => {
    return (
        <ButtonFilter type={type} logButton={logButton} onClick={onClick}>
            { text }
            <SvgArrowForward name="filter" /> 
        </ButtonFilter>
    )
}

export const InformationButton = ({ onClick }) => {
    return (
        <ButtonInformation onClick={onClick}>
            <span className="full_info"> Informações </span>
            <span className="mobile_info"> Info </span>
            <i className="gg-arrow-right" /> 
        </ButtonInformation>
    )
}

export const ScrollTop = ({ onClick }) => {
    return (
        <ButtonScrollTop onClick={onClick}>
           <SvgArrowUp />
        </ButtonScrollTop>
    )
}

export const LoadMoreButton = ({ onClick }) => {
    return (
        <LoadMore onClick={onClick}> 
            Carregar mais 
            <SvgArrowDownload name="download" />
        </LoadMore>
    )
}

export const GoBack = ({ onClick }) => {
    return (
        <GoBackButton onClick={onClick}>
            <SvgArrowBack />
        </GoBackButton>
    )
}

export const MobileBackHeader = ({ onClick }) => {
    return (
        <MobileBack onClick={onClick}>
            <SvgArrowBack name="mobile_header" />
        </MobileBack>
    )
}

export const DownloadResume = ({ onClick }) => {
    return (
        <ResumeDownload onClick={onClick}>
            <SvgFileDownload />
            <span> Baixar resumo </span>
        </ResumeDownload>
    )
}

export const Menu = ({ onClick }) => {
    return(
        <MenuIcon onClick={ onClick } className="gg-menu"/>
    )
}

export const LeftMaterial = ({ onClick, ml }) => {
    return (
        <LeftButton ml={ml}>
            <ArrowLeftIcon onClick={ onClick } className="gg-arrow-left" />
        </LeftButton>
    )
} 

export const FilterAdmin = ({ 
    dates = { }, 
    handleChangeInitial, 
    handleChangeFinal, 
    handleClearFilter,
    handleConfirmFilter 
}) => {

    const [ open, setOpen ] = useState(false)

    const handleClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setOpen(!open)
    }

    const handleConfirm = () => {
        handleConfirmFilter()
        setOpen(!open)
    }

    const handleClear = () => {
        handleClearFilter()
        setOpen(!open)
    }

    return (
        <AdminFilterWrapper >
            <AdminFilter onClick={(e) => handleClick(e)}>
                <SvgFilter />
                <span> Filtrar datas </span>
                <SvgChevronRight />
            </AdminFilter>
            { open && (
                <FilterDateWrapper onMouseLeave={(e) => setOpen(!open)}>
                    <DatePicker 
                        displayRange={false} 
                        weekdayFormat="eeeeee" 
                        dates={dates}
                        handleChangeInitial={handleChangeInitial} 
                        handleChangeFinal={handleChangeFinal}
                    />
                    <RangeDateFooter>
                        <RangeButton onClick={handleClear}> Limpar </RangeButton >
                        <RangeButtonFilter disabled={!dates.initial_date || !dates.final_date} onClick={handleConfirm}> Confirmar </RangeButtonFilter>
                    </RangeDateFooter>
                </FilterDateWrapper>
            ) } 
        </AdminFilterWrapper>
    )

}

export const AdmButton = ({ onclick, text }) => {
    return (
        <AdmButtonWrapper onClick={onclick}>
            { text }
            <SvgArrowForward />
        </AdmButtonWrapper>
    )
}

export const Choose = ({ onClick }) => {
    return (
        <ChooseWrapper onClick={onClick}>
            Contrate agora
        </ChooseWrapper>
    )
}

export const CommonButton = ({ width, text, onClick }) => {
    return (
        <CommomButtonWrapper onClick={onClick} width={width}> { text } </CommomButtonWrapper>
    )
}

export const MobileArrowdown = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    curosr: pointer;
    height: 34px;
    width: 34px;
    background: ${({ background }) => background || '#FF9800'};
    border-radius: 5px;
    align-self: center;
    margin-top: 14px;
    display: none;

    @media screen and (max-width: 768px) {
        display: flex;
    }
`
const TalkUs = styled.button`
    display: flex;
    width: 200px;
    height: 50px;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 25px;
    opacity: 1;
    border: none;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    color: #000;

    span {
        font-size: 18px;
        line-height: 27px;
        margin-left: 11px;
    }

    @media screen and (max-width: 950px) {
        width: 100%;
        margin-bottom: 62px;
    }
`
export const UnlockMarble = styled.button`
    display: flex;
    align-items: center;
    padding: 0 10px;
    width: 100%;
    max-width: 190px;
    height: 31px;
    justify-content: space-between;
    background: #FF9800;
    border-radius: 18px;
    cursor: pointer;
    outline: none;
    border: none;
    font-size: 10px;
    font-weight: bold;
    color: #000;

    @media screen and (max-width: 950px) {
        max-width: 156px;
        height: 26px;
        font-size: 8px;

        .text {
            line-height: 7px;
        }
    }
`
const DefaultWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    min-height: 41px;
    width: 100%;
    background: #FF9800 0% 0% no-repeat padding-box;
    border-radius: 48px;
    cursor: pointer;
    font-weight: bold;
    align-items: center;
    padding: 0 23px;
    justify-content: space-between;
`
const LoadMap = styled.button`
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 161px;
    height: 44px;
    background: #FF9800 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #FF9800;
    border-radius: 22px;
    font-size: 15px;
    line-height: 23px;
    cursor: pointer;
    font-weight: bold;
    margin-top: ${({ mtop }) => `${mtop}px`};
`
const Slider = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0 0 1 #eee;
    border-radius: 9px;
    min-height: 55px;
    min-width: 43px;
    outline: none;
    cursor: pointer;
    margin: 0 3px;
    border: 1px solid #c3c3c3;

    ${({ yellow }) => yellow && css`
        background: #FF9800 0% 0% no-repeat padding-box;
    `};
`
const Solution = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 278px;
    width: 100%;
    height: 60px;
    background: #fff;
    box-shadow: 1px 20px 35px #9191915E;
    font-size: 21px;
    line-height: 30px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    color: #000;

    @media only screen and (max-width: 950px) {
        max-width: 236px;
        font-size: 16px;
        line-height: 29px;
        height: 52px;
    }
`
const RegisterButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
    min-width: 278px;
    max-width: 278px;
    background: #FF9800 0% 0% no-repeat padding-box;
    box-shadow: 1px 20px 35px #FF98005E;
    border-radius: 8px;
    height: 60px;
    font-weight: bold;
    border: none;
    cursor: pointer;

    @media only screen and (max-width: 950px) {
      width: 100%;
      max-width: 100%;
      height: 52px;
      font-size: 16px;
      line-height: 29px;
      font-weight: 500;
    }
`
export const DefaultButton = ({ onClick, title }) => {
    return (
        <DefaultWrapper onClick={onClick}> { title } </DefaultWrapper>
    )
}

export const TalkToUs = ({ onClick, title }) => {
    return (
        <TalkUs onClick={onClick}> 
            <Phone phone />
            <span> Fale conosco </span>
        </TalkUs>
    )
}

export const LoadMoreMap = ({ onClick, mtop }) => {
    return (
        <LoadMap mtop={mtop} onClick={onClick}> Carregar mais </LoadMap>
    )
}

export const HeaderButton = ({ title, onClick }) => {
    return (
        <HeaderButtonWrapper onClick={onClick}>
            <span> { title } </span>
        </HeaderButtonWrapper>
    )
}

export const SlideButton = ({ onClick, yellow, forward }) => {
    return (
        <Slider yellow={yellow} onClick={onClick}>
            { forward ? <SvgArrowForward /> : <SvgArrowBack /> } 
        </Slider>
    )
}

export const ButtonSolution = ({ text, onClick }) => {
    return (
        <Solution onClick={onClick}> { text } </Solution>
    )
}

export const RegisterNewsletter = ({ text }) => {
    return (
        <RegisterButton> { text } </RegisterButton>
    )
}

export const ButtonUpload =({ onClick }) => {
    return (
        <UploadButton type="button" onClick={onClick}>
            <span> carregar arquivos </span>
            <i className='gg-software-upload'/>
        </UploadButton>
    )
}